import { Acertei } from '../@types/Acertei';
import Service from './Service';

export type QuestionSourcePayload = {
  description: string;
  fileKey?: string;
};

class QuestionSourceService extends Service {
  static list() {
    return this.Http.get<Acertei.definitions['QuestionSource'][]>('/question-sources').then(this.getData);
  }

  static create(payload: QuestionSourcePayload) {
    return this.Http.post<Acertei.definitions['QuestionSource']>('/question-sources', payload).then(this.getData);
  }

  static update(id: string, payload: Partial<QuestionSourcePayload>) {
    return this.Http.put<Acertei.definitions['QuestionSource']>(`/question-sources/${id}`, payload).then(this.getData);
  }

  static remove(id: string) {
    return this.Http.delete(`/question-sources/${id}`).then(this.getData);
  }
}

export default QuestionSourceService;
